module.exports = __webpack_public_path__ + "static/media/calendar.a7aa19d4.svg";